export default __webpack_public_path__ + "static/media/cross-mark.17852020.svg";